import ApplicationRecord from './ApplicationRecord';

export default class Unit
  extends ApplicationRecord({
    /**
     * @type {String}
     */
    id: -1,
    /**
     * Name of the unit
     * @type {String}
     */
    Title: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/Unit.js